import React from 'react'
import { Trans } from '@lingui/macro'
import { Box, ButtonOutline } from 'front-end/src/components'

import IconPlus2 from '../../../../components/common/icon/IconPlus2'

interface Props {
  icon: React.ReactNode
  title: React.ReactNode
  showButton: boolean
  onAdd: () => void
}

export const ItemsPaneHeader = ({ icon, title, showButton, onAdd }: Props) => {
  return (
    <div className="ItemsPane__header">
      <div className="ItemsPane__header__left">
        {icon}
        <Box as="h3" ml="6px">
          {title}
        </Box>
      </div>

      {showButton ? (
        <ButtonOutline size="sm" onClick={onAdd} leftIcon={<IconPlus2 />}>
          <Trans>Add</Trans>
        </ButtonOutline>
      ) : null}
    </div>
  )
}
